import React from "react";
import "./wpl-multiple-button-input.css";

export default function WplMultipleButtonInput({
  title,
  options,
  value,
  onChanged,
  style,
  className,
  ...rest
}) {
  return (
    <div
      className={`wpl-multiple-button-input ${className ? className : ""}`}
      style={style}
    >
      {title && <p className="title-label">{title}</p>}
      <div className="btn-group">
        {options.map((option, index) => (
          <button
            key={option}
            className={`btn ${value === option ? "active" : ""} ${index === 0 ? "first" : index === options.length - 1 ? "last" : ""
              }`}
            onClick={() => onChanged(option)}
            {...rest}
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
}
